// extracted by mini-css-extract-plugin
export default {"label":"WheelEcoLabel__label--xjILT","icon":"WheelEcoLabel__icon--UQaSj","score":"WheelEcoLabel__score--aIsW4"};